export type PostStatus = 'draft' | 'published' | 'deleted';

export interface PostFields {
  slug: string;
  title: string;
  description: string;
  date: string;
  author: string;
  category: string;
  tags: string[];
  featured: boolean;
  status: PostStatus;
  content: string;
}

/** Derive a URL-safe slug from a title. */
export function buildSlug(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/[\s-]+/g, '-');
}

/** Build the complete MDX file string from post fields. */
export function buildMdxFile(fields: PostFields): string {
  const tagsYaml = fields.tags.length
    ? '\ntags:\n' + fields.tags.map((t) => `  - ${t}`).join('\n')
    : '\ntags: []';

  return [
    '---',
    `title: "${fields.title.replace(/"/g, '\\"')}"`,
    `slug: "${fields.slug}"`,
    `description: "${fields.description.replace(/"/g, '\\"')}"`,
    `date: "${fields.date}"`,
    `author: "${fields.author}"`,
    `category: "${fields.category}"`,
    tagsYaml,
    `featured: ${fields.featured}`,
    `status: ${fields.status}`,
    '---',
    '',
    fields.content,
  ].join('\n');
}
